export default function formatPhoneNumber(value) {
  if (!value) return value;

  const extensionMatch = value.match(/(x|e|ex|ext)\d*$/);
  const extension = extensionMatch ? ` ${extensionMatch[0]}` : '';

  const phoneNumber = value.replace(/(x|e|ex|ext)\d*$/, '').replace(/[^\d]/g, '');

  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) return phoneNumber + extension;

  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}${extension}`;
  }

  if (phoneNumberLength < 11) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}${extension}`;
  }

  if (phoneNumberLength < 12) {
    return `+${phoneNumber[0]} (${phoneNumber.slice(1, 4)}) ${phoneNumber.slice(4, 7)}-${phoneNumber.slice(7, 11)}${
      extension}`;
  }

  if (phoneNumberLength < 13) {
    return `+${phoneNumber.slice(0, 2)} (${phoneNumber.slice(2, 5)}) ${phoneNumber.slice(5, 8)}-${
      phoneNumber.slice(8, 12)}${extension}`;
  }

  return `+${phoneNumber.slice(0, 2)} (${phoneNumber.slice(2, 5)}) ${phoneNumber.slice(5, 9)}-${
    phoneNumber.slice(9, 13)}${extension}`;
}
